import {
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/Reorder";
import { CartLineCollectionModel, OrderModel } from "@insite/client-framework/Types/ApiModels";

type ReorderParameter = {
    orderNumber: string;
} & HasOnSuccess &
    HasOnError<string>;

export interface ReorderResult {
    order: OrderModel;
    cartLines?: CartLineCollectionModel;
}

type HandlerType = ApiHandlerDiscreteParameter<ReorderParameter, CartLineCollectionModel>;


export const CustomExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};


replaceInChain(chain, ExecuteOnSuccessCallback, CustomExecuteOnSuccessCallback)
